import { languageIndex } from "@utils";
export const fields = (language) => {
    const index = languageIndex(language);
    return {
        title: ["Trainings", "Тренинги"][index],
        placeholder: ["Name", "Наименование документа"][index],
        addLabel: ["Add Training", "Добавить Тренинг"][index],
    };
};
